// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"bec8e409","289":"cb100d8d","324":"1bc6a768"}[chunkId] + ".js";
};